import React, { useState, useEffect, useContext, forwardRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { Typography, styled, Snackbar } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import Fab from "@mui/material/Fab";

import AddIcon from "@mui/icons-material/Add";
import Clear from "@mui/icons-material/Clear";
import Delete from "@mui/icons-material/Delete";
import { DeleteDialog } from "../components/DeleteDialog";

import { Link, Navigate } from "react-router-dom";

import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import MuiAlert from "@mui/material/Alert";
import SearchIcon from "@mui/icons-material/Search";
import Switch from "@mui/material/Switch";
import { doc as docRef, getDoc, collection, query, where, getDocs, setDoc, doc } from "firebase/firestore";
import { Context } from "context/Wrapper";
import { listenAndFilterTo, useAdvancedDataListener } from "apis/dataSnapshots";
import { db } from "config/config";
import useCustomParams from "components/shared/useCustomParams";
import AdvancedTable from "components/AdvancedTable";
import tableConfig from "config/advancedTableColumnsControl.json";
import { getBuildingBaseColumns, getBuildingDateUpdatedColumn, getBuildingColumnsWithHighlighting } from "config/buildingColumns";


const searchLimit = tableConfig?.searchMinLength;

const ListItem = styled(Paper)(({ theme, ...rest }) => {
  return {
    width: "100%",
    padding: theme.spacing(1),
    textAlign: "left",
    marginTop: theme.spacing(2),
    marginBottom: 0,
    color: theme.palette.primary.main,
    background: rest?.userGroupCheck
      ? theme.palette.secondary.secondary
      : theme.palette.secondary.main,
  };
});

let filterSearchedTimeout = null;


const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const Buildings = (props) => {



  const buildingLocationState = useLocation()


  const [feedbackMessage, setFeedbackMessage] = useState({
    open: buildingLocationState.state?.feedback?.message ? true : false,
    message: buildingLocationState.state?.feedback ? buildingLocationState.state?.feedback?.message : '',
    severity: buildingLocationState.state?.feedback ? buildingLocationState.state?.feedback?.severity : 'success',
  });


  const context = useContext(Context);
  const { params, updateParams } = useCustomParams();
  const { groupId, isPro } = context?.state?.userProfile || {};

  const user = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};

  // const { db, user, isPro, groupId, allData } = props;

  // const { db, user, isPro, groupId, allData } = props;
  const [buildings, setBuildings] = useState([]);

  const [filteredBuildings, setFilteredBuildings] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const sortField = params.get("sort") || "";
  const sortOrder = params.get("order") || "asc";

  const navigate = useNavigate();

  const fetchOwnerBusinessName = async (ownerId) => {
    if (!ownerId) return "";
    try {
      const snap = await getDoc(docRef(db, "contacts", ownerId));
      return snap.exists() ? snap.data().businessName || ownerId : ownerId;
    } catch {
      return ownerId;
    }
  };



  const fetchAndSearchAllBuildings = async () => {
    const buildingsRef = collection(db, "buildings");
    let baseFilters = [];

    if (showAllDataFlag && groupId) {
      baseFilters.push(where("groupId", "==", groupId));
    } else if (!showAllDataFlag && user.userId) {
      baseFilters.push(where("userId", "==", user.userId));
    }

    const snap = await getDocs(query(buildingsRef, ...baseFilters));

    const allDocs = await Promise.all(
      snap.docs.map(async (d) => {
        const data = d.data();
        const ownerName = await fetchOwnerBusinessName(data.owner);
        const fullAddress = [
          (data.houseNumber || "") + " " + (data.streetName || ""),
          data.city,
          data.state,
          data.ZIP,
        ]
          .filter(Boolean)
          .join(", ");
        return {
          ...data,
          id: d.id,
          fullAddress,
          ownerString: ownerName,
          ownerString_lc: (ownerName || "").toString().trim().toLowerCase(),
          fullAddress_lc: fullAddress.trim().toLowerCase(),
        };
      })
    );


    const queryLower = searchValue.toLowerCase();

    const filtered = allDocs
      .filter((item) => {
        return (
          (typeof item.customerReference === "string" &&
            item.customerReference.toLowerCase().includes(queryLower)) ||
          (typeof item.borough === "string" &&
            item.borough.toLowerCase().includes(queryLower)) ||
          (typeof item.fullAddress === "string" &&
            item.fullAddress.toLowerCase().includes(queryLower)) ||
          (typeof item.ownerString === "string" &&
            item.ownerString.toLowerCase().includes(queryLower)) ||
          (item.BIN &&
            item.BIN.toString().toLowerCase().includes(queryLower))
        );
      })
      .map((item) => {
        const highlight = (val) =>
          typeof val === "string"
            ? val.replace(
              new RegExp(searchValue, "gi"),
              (match) =>
                `<mark style="background: #2769AA; color: white;">${match}</mark>`
            )
            : val;

        return {
          ...item,
          displayCustomerReference: highlight(item.customerReference),
          displayBorough: highlight(item.borough),
          displayFullAddress: highlight(item.fullAddress),
          displayOwnerString: highlight(item.ownerString),
          displayBIN: highlight(item.BIN?.toString()),
        };
      });

    if (sortField) {
      filtered.sort((a, b) => {
        const aVal = a[sortField] ?? "";
        const bVal = b[sortField] ?? "";
        const cmp = String(aVal).localeCompare(String(bVal));
        return sortOrder === "asc" ? cmp : -cmp;
      });
    }


    setFilteredBuildings(filtered);
  };


  const [deleteOpen, setDeleteOpen] = useState(false);

  const [itemToDelete, setItemToDelete] = useState({
    itemId: "",
    identifier: "",
  });
  const { data, count, refetch } = useAdvancedDataListener({
    user,
    // conditions,
    // setLastRef: setLastVisible,
    condition: groupId && isPro && showAllDataFlag,
    defaultSortField: "dateCreated",
    defaultSortOrder: "desc",

    collectionName: "buildings",
    // rowsLimit,
    // params,
  });


  useEffect(() => {
    updateParams({
      page: "",
      search: "",
      pageIncreasing: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchValue.length >= searchLimit) {
      fetchAndSearchAllBuildings();
    } else {
      setFilteredBuildings([]);
    }
  }, [searchValue, showAllDataFlag]);



  const applySearchFilter = (buildingsArray = []) => {
    if (
      (searchValue?.length < searchLimit && searchValue?.length !== 0) ||
      !searchValue
    ) {
      if (searchValue?.length === 0) {
        updateParams({ search: "", pageSize: params.get("pageSize") });
      }

      if (sortField) {
        newArr.sort((a, b) => {
          const cmp = String(a[sortField] ?? "").localeCompare(String(b[sortField] ?? ""));
          return sortOrder === "asc" ? cmp : -cmp;
        });
      }

      setFilteredBuildings([]);
      return;
    }

    const newArr = buildingsArray
      .filter(
        (item) =>
          item.customerReference
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          item.borough
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          item.fullAddress
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          item.ownerString
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          item.BIN?.toString()
            .toLowerCase()
            .includes(searchValue.toLowerCase())
      )
      .map((item) => {
        const highlight = (val) =>
          val?.replace(
            new RegExp(searchValue, "gi"),
            (match) =>
              `<mark style="background: #2769AA; color: white;">${match}</mark>`
          );

        return {
          ...item,
          customerReference: highlight(item.customerReference),
          borough: highlight(item.borough),
          fullAddress: highlight(item.fullAddress),
          ownerString: highlight(item.ownerString),
          BIN: highlight(item.BIN?.toString()),
        };
      });

    setFilteredBuildings(newArr);
  };







  const handleInput = (e) => {
    let str = e.target.value;

    setSearchValue(str);
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const handleTrackChange = async (event, id) => {
    const thisBuilding = doc(db, "buildings", id);
    setDoc(thisBuilding, { track: event.target.checked }, { merge: true }).then(
      () => {
        console.log("updated");
      }
    );
  };

  const handleDelete = (id, identifier) => {
    setItemToDelete({ itemId: id, identifier: identifier });
    setDeleteOpen(true);
  };

  const dateUpdatedColumn = {
    field: "dateUpdated",
    headerName: "Last Updated",
    renderCell: ({ row }) => {
      if (!row.dateUpdated) return "";
      const d = typeof row.dateUpdated === "number"
        ? new Date(row.dateUpdated)
        : row.dateUpdated.toDate();
      return d.toISOString().split("T")[0];
    },
    sortComparator: (_, __, c1, c2) => {
      const a = c1.row.dateUpdated, b = c2.row.dateUpdated;
      const ms1 = typeof a === "number" ? a : a?.toMillis?.() || 0;
      const ms2 = typeof b === "number" ? b : b?.toMillis?.() || 0;
      return ms1 - ms2;
    },
  };



  useEffect(() => {
    const load = async () => {
      const withNames = await Promise.all(
        (data || []).map(async (doc) => {
          const ownerName = await fetchOwnerBusinessName(doc.owner);
          const fullAddress = [
            (doc.houseNumber || "") + " " + (doc.streetName || ""),
            doc.city,
            doc.state,
            doc.ZIP,
          ]
            .filter(Boolean)
            .join(", ");
          return {
            ...doc,
            fullAddress: [
              (doc.houseNumber || "") + " " + (doc.streetName || ""),
              doc.city,
              doc.state,
              doc.ZIP,
            ]
              .filter(Boolean)
              .join(", "),
            ownerString: ownerName,
            ownerString_lc: ownerName.trim().toLowerCase(),
            fullAddress_lc: fullAddress.trim().toLowerCase(),

          };
        })
      );

      setBuildings(withNames);

      if (searchValue?.length >= searchLimit) {
        const queryLower = searchValue.toLowerCase();
        const filtered = withNames
          .filter((item) => {
            return (
              item.customerReference?.toLowerCase().includes(queryLower) ||
              item.borough?.toLowerCase().includes(queryLower) ||
              item.fullAddress?.toLowerCase().includes(queryLower) ||
              item.ownerString?.toLowerCase().includes(queryLower) ||
              item.BIN?.toString().toLowerCase().includes(queryLower)
            );
          })
          .map((item) => {
            const highlight = (val) =>
              typeof val === "string"
                ? val.replace(
                  new RegExp(searchValue, "gi"),
                  (match) =>
                    `<mark style="background: #2769AA; color: white;">${match}</mark>`
                )
                : val;

            return {
              ...item,
              displayCustomerReference: highlight(item.customerReference),
              displayBorough: highlight(item.borough),
              displayFullAddress: highlight(item.fullAddress),
              displayOwnerString: highlight(item.ownerString),
              displayBIN: highlight(item.BIN?.toString()),
            };
          });

        setFilteredBuildings(filtered);
        setFilteredBuildings([]);
      }
    };

    load();
  }, [data, searchValue]);


  const confirmDelete = async () => {

    const buildingId = itemToDelete.itemId;

    try {
      const batch = db.batch();

      const buildingRef = db.collection("buildings").doc(buildingId);
      batch.delete(buildingRef);

      const filingsRef = db.collection("filings").where("buildingId", "==", buildingId);
      const filingsSnapshot = await filingsRef.get();

      filingsSnapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });

      await batch.commit();


      setBuildings((prevBuildings) =>
        prevBuildings.filter((building) => building.id !== buildingId)
      );

      refetch();

      openFeedbackMessage('Building deleted successfully!', 'success');
      setItemToDelete({ itemId: "", identifier: "" });
      setDeleteOpen(false);
      navigate("/buildings");
    } catch (error) {
      console.error("Error deleting building and associated filings: ", error);
      openFeedbackMessage('Failed to delete building. Please try again.', 'error');
    }
  };



  useEffect(() => {
    if (searchValue.length >= searchLimit) {
      fetchAndSearchAllBuildings();
    }
  }, [sortField, sortOrder]);


  useEffect(() => {
    const gridFilter = params.get("search") || "";
    setSearchValue(gridFilter);
  }, [params.get("search")]);



  const searchCheck = searchValue.length >= searchLimit;
  const buildingCollection = searchCheck ? filteredBuildings : buildings;



  const openFeedbackMessage = (message, severity) => {
    setFeedbackMessage({ open: true, message, severity });
  };

  const handleCloseFeedbackMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackMessage({ ...feedbackMessage, open: false });
  };





  return (
    <>
      <Fade in={true}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={8} style={{ position: "sticky" }}>
              <Typography align="left" variant="h4">
                BUILDINGS
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <Paper
                component="form"
                onSubmit={(e) => e.preventDefault()}
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "auto",
                }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  value={searchValue}
                  inputProps={{ "aria-label": "search" }}
                  onInput={handleInput}
                />

                {searchValue.length > 0 ? (
                  <IconButton
                    sx={{ p: "10px" }}
                    aria-label="search"
                    onClick={() => {
                      setSearchValue("");
                      updateParams({ search: "" });
                    }}
                  >
                    <Clear />
                  </IconButton>
                ) : (
                  <IconButton sx={{ p: "10px" }} aria-label="clear">
                    <SearchIcon />
                  </IconButton>
                )}
              </Paper>
            </Grid>
          </Grid>

          <AdvancedTable
            data={buildingCollection}
            collectionName="buildings"
            columnsRaw={[
              ...getBuildingColumnsWithHighlighting(),
              ...(tableConfig.buildings.dateUpdated ? [getBuildingDateUpdatedColumn()] : []),
            ]}

            rowCount={searchCheck ? buildingCollection?.length : count}
            // rowCount={searchCheck ? filteredBuildings.length : buildings.length}
            handleDelete={handleDelete}
            isInactive={props.isInactive}
          />
          <Box
            sx={{
              position: "fixed",
              bottom: "1rem",
              "& > :not(style)": { m: 1 },
            }}
          >
            <Link to="/buildings/new">
              {!props.isInactive && (
                <Fab
                  color="primary"
                  aria-label="add"
                  variant="extended"
                  disabled={props.isInactive}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  New
                </Fab>
              )}
            </Link>
          </Box>
        </div>
      </Fade>
      <DeleteDialog
        open={deleteOpen}
        confirmDelete={confirmDelete}
        setDialogOpen={setDeleteOpen}
        identifier={itemToDelete.identifier}
      />
      <Snackbar
        open={feedbackMessage.open}
        autoHideDuration={2000}
        onClose={handleCloseFeedbackMessage}
      >
        <Alert
          onClose={handleCloseFeedbackMessage}
          severity={feedbackMessage.severity}
          sx={{ width: "100%" }}
        >
          {feedbackMessage.message}
        </Alert>
      </Snackbar>
    </>
  );
};
